module.exports = __webpack_public_path__ + "assets/loyalty-promotion-pop-us.cc0fe01a.svg";